import { format } from 'date-fns';
import { es } from 'date-fns/locale';

// API URL
export const API_URL = process.env.REACT_APP_BACKEND_URL;

// Date presets for filtering
export const DATE_PRESETS = [
  { label: 'Este mes', value: 'this_month' },
  { label: 'Mes anterior', value: 'last_month' },
  { label: 'Últimos 3 meses', value: 'last_3_months' },
  { label: 'Este año', value: 'this_year' },
  { label: 'Personalizado', value: 'custom' },
];

// Format currency
export const formatCurrency = (value) => `Q ${value.toFixed(2)}`;

// Format date
export const formatDate = (dateStr) => format(new Date(dateStr), 'dd/MM/yyyy', { locale: es });
